import {
  AttestationFormStatus,
  CertificateType,
  OfferingType,
  SellingRestrictions,
} from '../../../../../../../graphql';
import { Attestation } from './useCertificatesModel';

export function getCertificateType(
  offeringType: OfferingType | undefined,
  isReg144A: boolean
): CertificateType | null {
  switch (offeringType) {
    case OfferingType.Convertible:
      return isReg144A ? CertificateType.Qib : null;
    case OfferingType.Ipo:
      return CertificateType.Form51305131;
    default:
      return null;
  }
}

export function isReg144A(
  instrument: { sellingRestrictions?: SellingRestrictions | null } | undefined | null
): boolean {
  return instrument?.sellingRestrictions === SellingRestrictions.Reg_144A;
}

export const CertificateTypeLabels: Record<CertificateType, string> = {
  [CertificateType.Qib]: 'QIB',
  [CertificateType.RegS]: 'Reg S',
  [CertificateType.Form51305131]: '5130/31',
};

export function getAttestationStatus(
  attestation: Attestation | null
): AttestationFormStatus | undefined {
  if (!attestation) return undefined;
  // For syndicate and sales & trading: status
  if ('status' in attestation && attestation.status) {
    return attestation.status as AttestationFormStatus;
  }
  // For buyside: formStatus
  if ('formStatus' in attestation && attestation.formStatus) {
    return attestation.formStatus as AttestationFormStatus;
  }
  return undefined;
}
